
class deSignatedCharity{
    constructor(){
        this.designated_charity = document.querySelector('#designated-charity');
        this.cart_component = document.querySelector('cart-items-component.cart-items-component');
        this.init();
    }
    init(){
      if(this.designated_charity){
        this.designated_charity.addEventListener('change', () => {
            if(this.cart_component.querySelector('.cart__checkout-button')){
              this.cart_component.querySelector('.cart__checkout-button').disabled = true;
            }
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: {
                "Designated Charity": this.designated_charity.value
              } })
            }).then(res => res.json())
            .then(cart => {
              console.log(cart);
              if(this.cart_component.querySelector('.cart__checkout-button')){
                this.cart_component.querySelector('.cart__checkout-button').disabled = false;
              }
            })
            .catch(error => console.error('Error:', error));
        });
      }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new deSignatedCharity();
});